import React from 'react';
import { Tag } from 'antd';
import {
    ClockCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    EditOutlined,
    StopOutlined
} from '@ant-design/icons';
import { UserStatus } from '../../types/admin.types';

interface StatusBadgeProps {
    status: UserStatus;
    size?: 'small' | 'default';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'default' }) => {
    const getStatusConfig = (status: UserStatus) => {
        switch (status) {
            case UserStatus.PENDING_MODERATION:
                return {
                    color: 'processing',
                    icon: <ClockCircleOutlined />,
                    text: 'Ожидает модерацию'
                };
            case UserStatus.ACTIVE:
                return {
                    color: 'success',
                    icon: <CheckCircleOutlined />,
                    text: 'Активен'
                };
            case UserStatus.REJECTED:
                return {
                    color: 'error',
                    icon: <CloseCircleOutlined />,
                    text: 'Отклонен'
                };
            case UserStatus.NEEDS_REVISION:
                return {
                    color: 'warning',
                    icon: <EditOutlined />,
                    text: 'На доработке'
                };
            case UserStatus.BLOCKED:
                return {
                    color: 'default',
                    icon: <StopOutlined />,
                    text: 'Заблокирован'
                };
            case UserStatus.VERIFIED:
                return {
                    color: 'cyan',
                    icon: <CheckCircleOutlined />,
                    text: 'Верифицирован'
                };
            default:
                return {
                    color: 'default',
                    icon: <ExclamationCircleOutlined />,
                    text: 'Неизвестно'
                };
        }
    };

    const config = getStatusConfig(status);

    return (
        <Tag
            color={config.color}
            icon={config.icon}
            className={size === 'small' ? 'text-xs' : ''}
        >
            {config.text}
        </Tag>
    );
};
